import React, { useEffect, useState } from 'react';
import moment from 'moment';
import classnames from 'classnames/bind';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Dashboard.module.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import * as $statistics from 'modules/statistics';

import { MainLayout } from 'view/layouts/Main';
import { DateRangePicker } from 'view/components/common/DateRangePicker';
import { StatisticsCard } from './StatisticsCard';

const cls = classnames.bind(styles);

export const Dashboard = () => {
  const dispatch = useDispatch();
  const report = useSelector($statistics.getSalesReport);

  const [startDate, setStartDate] = useState(moment().subtract(1, 'week').toDate());
  const [endDate, setEndDate] = useState(moment().toDate());

  useEffect(() => {
    dispatch(
      $statistics.fetchSalesReport({
        fromDate: startDate,
        toDate: endDate,
      })
    );
  }, [startDate, endDate, dispatch]);

  return (
    <MainLayout>
      <div className={cls('container')}>
        <span className={cls('date-range-label')}>Date range:</span>
        <DateRangePicker
          dateRange={[startDate, endDate]}
          onChange={({ startDate, endDate }) => {
            setStartDate(startDate);
            setEndDate(endDate);
          }}
        />

        <div className={cls('stats')}>
          <StatisticsCard
            title="Orders"
            data={report.Count}
            color={'#9368d7'}
            tooltipLabel="Orders"
          />
          <StatisticsCard
            title="Revenue"
            data={report.TotalPrice}
            formatLabel={(value) => (
              <>
                <span className={cls('currency-symbol')}>₪</span>
                {Math.round(value)}
              </>
            )}
            color={'#d36f5b'}
            tooltipLabel="Revenue"
          />
          <StatisticsCard
            title="Commission"
            data={report.TotalCommission}
            formatLabel={(value) => (
              <>
                <span className={cls('currency-symbol')}>₪</span>
                {Math.round(value)}
              </>
            )}
            color={'#4bade1'}
            tooltipLabel="Commission"
          />
        </div>
      </div>
    </MainLayout>
  );
};
